import { ClipboardList } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import SurveyDirectoryPage from "./pages/SurveyDirectoryPage";
import { FEATURE_FORMS } from "../../utils/UserAccessControlUtils";
import SurveyCreatePage from "./pages/SurveyCreatePage";

const SurveyRouter: NavigationLinkProps[] = [
  {
    id: "9435956b-c3d4-4025-9372-3d365df9ccfb",
    title: "Surveys",
    description: "",
    path: "/surveys",
    auth: true,
    sidebar: true,
    icon: ClipboardList,
    component: SurveyDirectoryPage,
    requiredFeature: FEATURE_FORMS,
    requiredPermissions: ["ANY"],
  },
  {
    id: "9435956b-c3d4-c3d4-9372-3d365df9ccfb",
    title: "Surveys",
    description: "",
    path: "/surveys/create",
    auth: true,
    sidebar: false,
    icon: ClipboardList,
    component: SurveyCreatePage,
    requiredFeature: FEATURE_FORMS,
    requiredPermissions: ["ANY"],
  },
];

export default SurveyRouter;
